<template>
  <div class="row no-gutters justify-content-end mb-2">
    <a :href="newAuctionPath" class="btn btn__primary">
      {{I18n.t(`auctions_catalogs.create_${auctionType}_auction`)}}
    </a>
  </div>
</template>

<script>
/* global Routes */
export default {
  created() {
    this.Routes = Routes;
  },
  name: 'CreateAuctionButton',
  computed: {
    auctionType() {
      return window.location.pathname.split('/')[2];
    },
    newAuctionPath() {
      return this.Routes[`new_employees_${this.auctionType}_auctions_catalog_path`]();
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/auctions_catalogs/index/components/create_auction_button.vue?4d0ab060